import React, { useEffect } from "react";
import imgReal from "../img/kakaoReal.png";
import "./KakaoShareButton.css";
const KakaoShareButton = () => {
  useEffect(() => {
    createKakaoButton();
  }, []);

  const createKakaoButton = () => {
    // kakao sdk script이 정상적으로 불러와졌으면 window.Kakao로 접근이 가능합니다
    if (window.Kakao) {
      const kakao = window.Kakao;

      // 중복 initialization 방지
      if (!kakao.isInitialized()) {
        // 두번째 step 에서 가져온 javascript key 를 이용하여 initialize
        kakao.init("5fa7979918950538fddff35e13bc2e44");
      }

      kakao.Link.createDefaultButton({
        // Render 부분 id=kakao-link-btn 을 찾아 그부분에 렌더링을 합니다
        container: "#kakao-link-btn",
        objectType: "feed",
        content: {
          title: "🙉무한도전 닮은꼴 테스트",
          description:
            "AI가 알려주는 무한도전 얼굴상! #유재석 #박명수 #정준하 #노홍철 #정형돈 #하하 #길",
          //   imageUrl: "IMAGE_URL", // i.e. process.env.FETCH_URL + '/logo.png'
          imageUrl:
            "https://img6.yna.co.kr/etc/inner/KR/2018/01/12/AKR20180112117600005_01_i_P4.jpg",
          link: {
            mobileWebUrl: window.location.href,
            webUrl: window.location.href,
          },
        },
        // social: {
        //   likeCount: 77,
        //   commentCount: 55,
        //   sharedCount: 333,
        // },
        buttons: [
          {
            title: "웹으로 보기",
            link: {
              mobileWebUrl: window.location.href,
              webUrl: window.location.href,
            },
          },
          //   {
          //     title: "앱으로 보기",
          //     link: {
          //       mobileWebUrl: window.location.href,
          //       webUrl: window.location.href,
          //     },
          //   },
        ],
      });
    }
  };

  return (
    <div className="kakao-share-button">
      {/* Kakao share button */}
      <button id="kakao-link-btn">
        <img src={imgReal} alt="kakao-share-icon" /> <span> 공유하기</span>
      </button>
    </div>
  );
};

export default KakaoShareButton;
